import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Administration() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Administration & Staffing Solutions</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/administration.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Create efficient operations and build a productive workforce with comprehensive administrative and HR support.</p>
                        <h2 style={{fontWeight:'bold'}}>What We Provide</h2>
                        <p>
                            <ul>
                                <li><b>Process documentation (SOPs)</b> <br /><br/></li>
                                <li><b>Recruitment and onboarding</b> <br /><br/></li>
                                <li><b>Payroll and benefits management</b> <br /><br/></li>
                                <li><b>Employee performance frameworks</b> <br/><br/></li>
                                <li><b>Compliance and safety protocols</b></li>
                            </ul>
                        </p>
                       
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{fontWeight:'bold'}}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Reduced inefficiencies   
                                </li>
                                <li><span class="arrow">➤</span>Legal compliance</li>
                                <li><span class="arrow">➤</span>Proven Success </li>
                                <li><span class="arrow">➤</span>Higher employee engagement</li>
                                <li><span class="arrow">➤</span>Scalable operations</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/advertv.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />
                            
                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
